// Firebase 설정
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase 설정 - Firebase 콘솔에서 복사한 실제 설정으로 교체
const firebaseConfig = {
  apiKey: "AIzaSyA24nhZqCQYH19hOdDF12rmonxaqeveEGs",
  authDomain: "seoul-junior-dental.firebaseapp.com",
  projectId: "seoul-junior-dental",
  storageBucket: "seoul-junior-dental.firebasestorage.app",
  messagingSenderId: "172462285586",
  appId: "1:172462285586:web:b2875c9cc09cb499ec49cb",
  measurementId: "G-Z94FQB792E"
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Firebase 서비스 초기화
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app; 